<footer class="text-white bg-blue1" *transloco="let t;">
  <div class="w-full border-b border-white flex justify-around p-8 gap-4 flex-wrap md:flex-nowrap">
    <div class="w-full md:w-1/3 flex flex-col gap-[20px] items-center justify-center">
      <img class="h-[60px] " src="assets/svg/pvc-logo-white.svg" alt="PV Smart Click logo">
      <div>{{ t('footer.slogan') }}</div>
    </div>

    <div class="w-full md:w-1/3 flex flex-col justify-around items-center">
      <h5>{{ t('footer.company') }}</h5>
      <div class="flex flex-col items-center mb-5">
        <div>{{ companyInfo.name  }}</div>
        <div>{{ companyInfo.address }}</div>
        <div>{{ companyInfo.oib }}</div>
      </div>
    </div>

    <div class="w-full md:w-1/3 flex flex-col gap-2 justify-around items-center">
      <h5>{{ t('footer.contactUs') }}</h5>
      <a href="mailto: {{contactInfo.email}}">{{contactInfo.email}}</a>
      <div>
        <span>{{ contactInfo.phone1 + '; ' }}</span>
        <span>{{ contactInfo.phone2 }}</span>
      </div>
      <div class="flex gap-2">
        <a *ngFor="let media of socialMedia" [href]="media.link" target="_blank">
          <img src="assets/svg/{{media.icon}}.svg" [alt]="media.alt"/>
        </a>
      </div>
    </div>
  </div>

  <div class="flex justify-center items-center p-8">
    <div class="mr-2">{{ t('footer.allRightsReserved') }}</div>
    <img class="h-[40px]" src="assets/svg/digital-arena-white.svg" alt="Digital Arena logo">
  </div>
  <div class="flex pl-2 pb-1">v{{appVersion}}</div>
</footer>
